// Web shim for @react-native-async-storage/async-storage using localStorage

const AsyncStorage = {
  async getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  async setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // storage full or unavailable
    }
  },

  async removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore
    }
  },

  async multiGet(keys) {
    return keys.map((key) => [key, localStorage.getItem(key)]);
  },

  async multiSet(pairs) {
    pairs.forEach(([key, value]) => localStorage.setItem(key, value));
  },

  async multiRemove(keys) {
    keys.forEach((key) => localStorage.removeItem(key));
  },

  async clear() {
    localStorage.clear();
  },

  async getAllKeys() {
    return Object.keys(localStorage);
  },
};

export default AsyncStorage;
